<template>
  <header
    class="header bg-ffffff box-shadow-3 pl-21 pr-17 pt-10 pb-10 pb-xl-15"
    :class="{ 'index-up': isShowUserHeader }"
  >
    <div class="app-header-wrapper">
      <div class="row align-items-center no-gutters">
        <div class="col-auto pl-10 pl-xl-15">
          <div class="app-header__logo-desktop">
            <div
              class="pointer d-none d-xl-flex align-items-center"
              @click="goRoot"
            >
              <img src="/images/login-logo.png" alt="GrowthPad" height="26px" />
            </div>
            <div class="d-flex align-items-center d-xl-none">
              <div class="text-center">
                <div>
                  <img
                    class="logo"
                    src="/images/favicon.png"
                    alt="logo-mobile"
                  />
                </div>
                <div>
                  <img
                    class="hamb"
                    src="/images/hamb.png"
                    alt="logo-mobile"
                    @click="switchSideBarContent"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col position-relative">
          <div class="header-text mr-30 pointer" @click="goRoot">
            <img src="/images/login-logo.png" alt="GrowthPad" height="26px" />
          </div>
          <!-- スマホ版: 学習統計バッジ（中央カラムに配置） -->
          <learning-stats
            v-if="learningStatistics"
            :statistics="learningStatistics"
            class="d-sm-block d-lg-none mobile-stats-badge"
          />
        </div>
        <div class="col-auto pr-10 pr-xl-15">
          <div
            class="app-header__sidebar-left-content d-none align-items-center justify-content-end"
          >
            <div
              class="icon-one"
              style="cursor: pointer"
              @click="showUserHeader"
            >
              <base-avatar
                class="flex-shrink-0"
                size="large"
                :src="currentUser.avatar"
                :name="displayName"
              />
            </div>
          </div>
          <div
            class="app-header__user-info d-flex align-items-center justify-content-end"
          >
            <!-- PC版: 学習統計を表示 -->
            <learning-stats
              v-if="learningStatistics"
              :statistics="learningStatistics"
              class="mr-8 d-none d-lg-block flex-shrink-0"
            />
            <div class="d-none d-xl-flex flex-column mr-10">
              <div class="fs-14 text-right f-500 cl-1c1c1e lh-15"
                >{{ currentUser.name }}
              </div>
              <span class="fs-12 f-400 cl-798b96 lh-15">{{
                currentUserDisplayName
              }}</span>
            </div>
            <div class="dropdown-custom-user">
              <b-dropdown no-caret>
                <template #button-content>
                  <div
                    class="app-header__user-img bg-beced6 border-radius-100 text-center"
                    ><img
                      v-if="currentUser.avatar"
                      :src="currentUser.avatar"
                    /><span v-else class="text fs-14 cl-ffffff">{{
                      $utils.string.getFirstChar(displayName)
                    }}</span></div
                  >
                </template>
                <b-dropdown-item class="not-hover-item">
                  <div class="d-flex justify-content-between">
                    <div>
                      <base-avatar
                        class="flex-shrink-0"
                        size="large"
                        :src="currentUser.avatar"
                        :name="displayName"
                      />
                      <div class="fs-14 f-500 cl-1c1c1e lh-15 mt-5"
                        >{{ currentUser.name }}
                      </div>
                      <span class="fs-12 f-400 cl-798b96 lh-15">{{
                        currentUserDisplayName
                      }}</span>
                    </div>
                    <base-icon
                      iconName="close"
                      :size="10"
                      @click="hideUserHeader"
                    />
                  </div>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="showProfileModal"
                  >プロフィール
                </b-dropdown-item>
                <!-- 一旦非表示：コンテクスト登録はCS側（管理画面）で運用するため
                <b-dropdown-item @click="$bvModal.show('readme-modal')"
                  >Readme登録
                </b-dropdown-item>
                -->
                <b-dropdown-item @click="goToUserActivity()"
                  >活動履歴
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  href="https://growthpad.zendesk.com/"
                  target="_blank"
                  >ヘルプ
                </b-dropdown-item>
                <b-dropdown-item
                  href="https://growthpad.zendesk.com/hc/ja/articles/12546337544473-GrowhtPad-%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84"
                  target="_blank"
                  >利用規約
                </b-dropdown-item>
                <b-dropdown-item
                  href="https://grtx.jp/privacypolicy"
                  target="_blank"
                >
                  プライバシーポリシー
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="logout">ログアウト</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="app-header-user-mobile d-none"
      :class="{ open: isShowUserHeader }"
    >
      <div class="app-header__user-top pt-25 px-25 pb-15 bg-ffffff">
        <div
          class="icon-close-user-header text-right"
          style="cursor: pointer"
          @click="hideUserHeader"
        >
          <svg
            width="14"
            height="14"
            viewbox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.71967 0.71967C1.01256 0.426777 1.48744 0.426777 1.78033 0.71967L7 5.93934L12.2197 0.71967C12.5126 0.426777 12.9874 0.426777 13.2803 0.71967C13.5732 1.01256 13.5732 1.48744 13.2803 1.78033L8.06066 7L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L7 8.06066L1.78033 13.2803C1.48744 13.5732 1.01256 13.5732 0.71967 13.2803C0.426777 12.9874 0.426777 12.5126 0.71967 12.2197L5.93934 7L0.71967 1.78033C0.426777 1.48744 0.426777 1.01256 0.71967 0.71967Z"
              fill="#42515F"
            ></path>
          </svg>
        </div>
        <div class="app-header__user-info mt-10">
          <base-avatar
            class="flex-shrink-0"
            size="medium"
            :src="currentUser.avatar"
            :name="displayName"
          />
          <div class="fs-14 text-left f-500 cl-1c1c1e lh-15"
            >{{ currentUser.name }}
          </div>
          <div class="fs-12 f-400 cl-798b96 lh-15"
            >{{ currentUserDisplayName }}
          </div>
        </div>
      </div>
      <div class="app-header__user-link h-100 bg-ffffff">
        <div class="item px-25 py-13 fs-14 cl-000000" @click="showProfileModal"
          >プロフィール
        </div>
        <!-- 一旦非表示：コンテクスト登録はCS側（管理画面）で運用するため
        <div
          class="item px-25 py-13 fs-14 cl-000000"
          @click="$bvModal.show('readme-modal')"
          >Readme登録
        </div>
        -->
        <div
          class="item px-25 py-13 fs-14 cl-000000"
          @click="goToUserActivity()"
          >活動履歴
        </div>
        <a
          href="https://growthpad.zendesk.com/"
          target="_blank"
          class="item d-block px-25 py-13 fs-14 cl-000000 text-decoration-none"
        >
          ヘルプ
        </a>
        <a
          href="https://growthpad.zendesk.com/hc/ja/articles/12546337544473-GrowhtPad-%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84"
          target="_blank"
          class="item d-block px-25 py-13 fs-14 cl-000000 text-decoration-none"
        >
          利用規約
        </a>
        <a
          href="https://grtx.jp/privacypolicy"
          target="_blank"
          class="item d-block px-25 py-13 fs-14 cl-000000 text-decoration-none"
        >
          プライバシーポリシー
        </a>
        <div class="item px-25 py-13 fs-14 cl-000000" @click="logout">
          ログアウト
        </div>
      </div>
    </div>
    <div
      class="bg-overlay bg-show-user-header"
      :class="{ open: isShowUserHeader }"
      @click="hideUserHeader"
    ></div>
    <user-profile-modal :is-my-page="true"></user-profile-modal>
    <!-- 一旦非表示：コンテクスト登録はCS側（管理画面）で運用するため
    <user-readme-modal></user-readme-modal>
    -->
  </header>
</template>

<script lang="ts">
import { Component, Watch, Vue } from 'vue-facing-decorator'
import { Action, State, namespace } from 'vuex-facing-decorator'
import type { User } from '@/model/user/schema'
import UserProfileModal from '@/components/domain/user/UserProfileModal.vue'
import UserReadmeModal from '@/components/domain/user/UserReadmeModal.vue'
// https://github.com/Thinqlo/GrowthPad/issues/1197
// import QuestionSearchContent from '@/components/domain/question/QuestionSearchContent/index.vue'
import BaseAvatar from '@/components/base/Avatar/index.vue'
import BaseIcon from '@/components/base/Icon/index.vue'
import LearningStats, {
  LearningStatistics
} from '@/components/domain/site/LearningStats.vue'
import UserModel from '@/model/user'
import SkillModel from '@/model/skill'
import WatchHistoryModel from '@/model/watchHistory'
import { SpPageContentList } from '@/model/spPage/schema'

const AuthStore = namespace('auth')
const DataStore = namespace('data')

@Component({
  components: {
    'user-profile-modal': UserProfileModal,
    'user-readme-modal': UserReadmeModal,
    // https://github.com/Thinqlo/GrowthPad/issues/1197
    // 'question-search-content': QuestionSearchContent,
    'base-avatar': BaseAvatar,
    'base-icon': BaseIcon,
    'learning-stats': LearningStats
  }
})
export default class SiteHeader extends Vue {
  @Action toggleUserHeader
  @Action toggleSideBarContent
  @Action toggleNavigationBar
  @State isShowUserHeader
  @State currentSkill
  @State isShowSideBarContent
  @DataStore.Action clear: () => void
  @AuthStore.Getter currentUser: User

  learningStatistics: LearningStatistics | null = null

  created() {
    Promise.all([
      this.getSkillCategories(),
      this.getCompanyUsers(),
      this.fetchLearningStatistics()
    ])
  }

  async getSkillCategories() {
    await SkillModel.fetchSkillCategories({
      options: {
        ignoreCache: true
      }
    })
  }

  async getCompanyUsers() {
    await UserModel.fetchMyCompanyUsers({
      options: {
        ignoreCache: true
      }
    })
  }

  async fetchLearningStatistics() {
    try {
      const data: SpPageContentList = await WatchHistoryModel.fetch({
        options: { ignoreCache: false }
      })
      if (data.statistics) {
        this.learningStatistics = data.statistics
      }
    } catch (error) {
      console.error('Failed to fetch learning statistics:', error)
    }
  }

  goRoot() {
    if (this.$route.name !== 'Home') {
      this.$router.push({ name: 'Home' })
    }
  }

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange() {
    this.toggleSideBarContent(false)
    this.toggleUserHeader(false)
    this.toggleNavigationBar(false)
  }

  // computed
  get currentUserDisplayName(): string {
    return `${this.currentUser.name}@${this.currentUser.company_name}`
  }

  get displayName(): string {
    return this.currentUser.name
  }

  get isHomePage(): boolean {
    return this.$route.name === 'Home'
  }

  get isSearchPage(): boolean {
    return this.$route.name === 'Search'
  }

  get isSkillQuestionsPage(): boolean {
    return this.$route.name === 'SkillQuestion'
  }

  get pageTitle(): string {
    if (this.isHomePage) return 'ホーム'
    if (this.isSearchPage) return '検索結果一覧'
    if (this.isSkillQuestionsPage) {
      return this.currentSkill ? this.currentSkill.name : ''
    }
    return ''
  }

  // methods
  async logout() {
    await this.$auth.logout({
      makeRequest: false,
      redirect: { name: 'VerifyEmailAddress' }
    })

    // clear all cached data
    this.clear()
  }

  showUserHeader() {
    this.toggleUserHeader(true)
    this.toggleSideBarContent(false)
  }

  hideUserHeader() {
    this.toggleUserHeader(false)
  }

  showProfileModal() {
    this.$bvModal.show('profile-modal')
    this.hideUserHeader()
  }

  switchSideBarContent() {
    this.toggleSideBarContent(!this.isShowSideBarContent)
    this.toggleUserHeader(false)
  }

  goToUserActivity() {
    const publicId = this.currentUser.userPublicId
    if (!publicId) return
    this.$router.push({ name: 'UserActivity', params: { userHash: publicId } })
    this.hideUserHeader()
  }

  showNavigationBar() {
    this.toggleNavigationBar(true)
  }

  onCreateQuestion() {
    if (this.isSkillQuestionsPage || this.isHomePage) {
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, tab: 'mine', question_created: 'true' }
      })
    } else {
      this.$router.push({
        path: '/',
        query: { ...this.$route.query, tab: 'mine', question_created: 'true' }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
header {
  text-align: center;
}

.header-text {
  display: none;
  @media (max-width: 575px) {
    display: flex;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
  }
}

.logo {
  cursor: pointer;
  width: 30px;
  height: 30px;
  @media (max-width: 769px) {
    display: none;
  }
}

.hamb {
  cursor: pointer;
  height: 18px;
  @media (min-width: 768px) {
    display: none;
  }
}

.pointer {
  cursor: pointer;
}

.mobile-stats-badge {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  z-index: 50;

  @media (max-width: 575px) {
    right: 5px;
  }
}
</style>

<style lang="scss" module>
.ProfileDropDown {
  width: 264px;
}
</style>
